import React from 'react';
import { Link } from 'react-router-dom';
import logo1 from "../../logo1.png";
import logo2 from "../../white1.png";

const Footer = ({ isDarkMode }) => {
    const logo = isDarkMode ? logo2 : logo1;
    return (
        <footer className={`footer ${isDarkMode ? 'dark-mode' : ''}`} style={{ backgroundColor: isDarkMode ? '#333' : '#f8f9fa', textAlign: "center", marginTop: "25px" }}>
            <div className="container-fluid"> {/* Use container-fluid to prevent horizontal overflow */}
                <div className="row justify-content-center">
                    <div className="col-12 col-md-auto">
                        <img src={logo} alt="Website Logo" style={{ maxWidth: "200px", width: "100%", height: "auto" }} />
                    </div>
                    <div className="col-12 col-md-auto mt-2">
                        <div className="d-flex flex-wrap justify-content-center">
                            <Link to="/term" className="text-decoration-none me-md-4 mb-2 mb-md-0" style={{ color: isDarkMode ? '#f8f9fa' : '#333', margin: '0 5px' }}>Terms of Service</Link>

                            <Link to="/privacy" className="text-decoration-none me-md-4 mb-2 mb-md-0" style={{ color: isDarkMode ? '#f8f9fa' : '#333', margin: '0 5px' }}>Privacy</Link>
                            <Link to="/aboutus" className="text-decoration-none mb-2 mb-md-0" style={{ color: isDarkMode ? '#f8f9fa' : '#333', margin: '0 5px' }}>About Us</Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>

    );
};

export default Footer;
